<!-- <app-header></app-header>
<app-sidebar></app-sidebar>

<main class="full-wrap">
    <div class="main-div">
        <div class="left-section">
            <div class="report-page">
                <div class="page-title">
                    <h3>Profit & Loss</h3>
                    <div class="breadcrumb">
                        <a (click)="goToBack()" class="btn btn-secondary back-btn"><i class="fa fa-arrow-left"></i>Back</a>
                    </div>
                </div>
                <div class="filterDiv">
                    <div class="row">
                        <div class="col-md-12">
                            <div>
                                <div class="row form-field">
                                    <div class="col-md-2">
                                        <div class="col-inner">
                                            <div class="form-group dateTimePicker">
                                                <input type="text" class="form-control" [popover]="popTemplate"
                                                    placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                    value="{{dateTime | date:'yyyy-MM-dd hh:mm'}}" (click)="showDate()">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="col-inner">
                                            <div class="form-group dateTimePicker">
                                                <input type="text" class="form-control" [popover]="popTemplate"
                                                    placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                    value="{{dateTime | date:'yyyy-MM-dd hh:mm'}}" (click)="showDate()">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="col-inner">
                                            <div class="form-group">
                                                <select class="form-select" aria-label="Default select example">
                                                    <option selected>Select Sport Name</option>
                                                    <option value="1">All</option>
                                                    <option value="2">Cricket</option>
                                                    <option value="3">Soccer</option>
                                                    <option value="4">Tennis</option>
                                                    <option value="5">Exchange Games</option>
                                                    <option value="6">Fancy</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="col-inner text-end">
                                            <div class="btn-list">
                                                <button type="button" class="btn btn-success">Filter</button>
                                                <button type="button" class="btn btn-danger">Clear</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="report-table">
                            <table datatable class="table">
                                <thead>
                                    <tr>
                                        <th><input type="checkbox"></th>
                                        <th>Event Name</th>
                                        <th>Market</th>
                                        <th>Created On</th>
                                        <th>P | L</th>
                                        <th>Commission</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="checkbox"></td>
                                        <td>Date</td>
                                        <td>Name</td>
                                        <td>Description</td>
                                        <td>Credit</td>
                                        <td>Debit</td>
                                        <td>Balance</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main> -->


<div class="app-body">
    <app-header></app-header>
      <div class="full-wrap">
        <div class="col-left">
          <div class="sub_path">
            <div class="path">
              <a href="#path-pop" class="path-back">...</a>
              <ul>
                <li class="path-last"><a href="#">My Account</a></li>
              </ul>
            </div>
            <ul class="menu-list" data-widget="tree">
                <li>
                  <a (click)="info()" class="select">
                    <span>My Profile</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="rollComission()">
                    <span>Rolling Commision</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="statement()">
                    <span>Account Statement</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/betHistory']">
                    <span>Bets History</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="profitLoss()">
                    <span>Profit & Loss</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="history()">
                    <span>Password History</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="activity()">
                    <span>Activity Log</span><span class="pull-right-container"></span>
                  </a>
                </li>
            </ul>
          </div>
        </div>
  
        <div id="centerColumn" class="col-center report">
          <!-- Loading Wrap -->
          <div id="loading" class="loading-wrap" style="top: 100px; display: none;">
              <ul class="loading">
                  <li><img src="assets/sky_img/loading40.gif"></li>
                  <li>Loading...
                  </li>
                  <br>
                  <li><span id="progress"></span></li>
              </ul>
          </div>
          
          <h2>Bet History</h2>
          <ul class="tab col3">
            <li><a [routerLink]="['/betHistory']">Current Bets</a> </li>
            <li><a [routerLink]="['/betHistory']">Bets History</a></li>
            <li><a class="select" [routerLink]="['/profit-loss']">Profit & Loss</a></li>
          </ul>  
          <div class="tab-content">
            <h3>Profit &amp; Loss - Main wallet</h3>
              <ul class="acc-info">
                <li class="user">sjohn1</li>
                <li class="time">2022-12-27 13:13</li>
              </ul>
              <ul class="tab report-tab-wrap" id="filter-tab" role="tablist">
                <li class="report-tab" role="presentation">
                  <a class="select active" id="filter-exchange-tab" data-bs-toggle="pill" data-bs-target="#filter-exchange" role="tab" aria-controls="filter-exchange" aria-selected="true">Exchange</a>
                </li>
                <li class="report-tab" role="presentation">
                  <a id="filter-fancyBet-tab" data-bs-toggle="pill" data-bs-target="#filter-fancyBet" role="tab" aria-controls="filter-fancyBet" aria-selected="false">Fancy Bet</a>
                </li>
                <li class="report-tab" role="presentation">
                  <a id="filter-sportBook-tab" data-bs-toggle="pill" data-bs-target="#filter-sportBook" role="tab" aria-controls="filter-sportBook" aria-selected="false">Sportsbook</a>
                </li>
                <li class="report-tab" role="presentation">
                  <a id="filter-bookMaker-tab" data-bs-toggle="pill" data-bs-target="#filter-bookMaker" role="tab" aria-controls="filter-bookMaker" aria-selected="false">BookMaker</a>
                </li>
                <li class="report-tab" role="presentation">
                  <a id="filter-binary-tab" data-bs-toggle="pill" data-bs-target="#filter-binary" role="tab" aria-controls="filter-binary" aria-selected="false">Binary</a>
                </li>
              </ul> 
              
              <div id="filter-tabContent" class="tab-content">
                <div class="tab-pane fade show active" id="filter-fancyBet" role="tabpanel" aria-labelledby="filter-fancyBet-tab" tabindex="0">
                  <div class="function-wrap">
                    <ul class="input-list">
                      <li><label>Period</label></li>
                      <li style="display: flex;">
                        <input type="text" class="form-control" [popover]="popTemplate"
                                                    placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                    value="{{dateTime | date:'yyyy-MM-dd hh:mm'}}" (click)="showDate()">
                        to
                        <input type="text" class="form-control" [popover]="popTemplate"
                                                    placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                                                    value="{{dateTime | date:'yyyy-MM-dd hh:mm'}}" (click)="showDate()">
                      </li>
                    </ul>
                    <ul class="input-list">
                      <li><a id="today" class="btns">Just For Today</a></li>
                      <li><a id="yesterday" class="btns">From Yesterday</a></li>
                      <li><a id="getPL" class="btn-send">Get P & L</a></li>
                    </ul>
                  </div>
                  
                  <table id="tableTemplate" class="table01 table-pnl">
                    <tbody>
                      <tr>
                        <th width="" class="align-L">Market</th>
                        <th width="15%">Start Time</th>
                        <th width="15%">Settled date</th>
                        <th width="18%">Profit/Loss</th>
                      </tr>
                      <tr>
                        <td class="align-L"></td>
                        <td></td>
                        <td></td>
                        <td>
                          <a class="expand-close" href="javascript: void(0);"></a>
                        </td>
                      </tr>
                      <tr class="expand">
                        <td colspan="4">
                          <img class="expand-arrow-R" src="assets/sky_img/transparent.gif">
                          <table class="table-commission">
                            <tbody>
                              <tr>
                                <th width="9%">Bet ID</th>
                                <th width="">Selection</th>
                                <th width="9%">Odds</th>
                                <th width="13%">Stake</th>
                                <th width="8%">Type</th>
                                <th width="16%">Placed</th>
                                <th width="23%">Profit/Loss</th>
                              </tr>
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><span></span></td>
                                <td></td>
                                <td></td>
                              </tr>
                            <tr class="sum-pl">
                              <td colspan="7">
                                <dl>
                                  <dt>Total Stakes</dt>
                                  <dd></dd>
                                  
                                  <dt>Back subtotal</dt>
                                  <dd id="backSubTotal"></dd>
                                  
                                  <dt>Lay subtotal</dt>
                                  <dd></dd>
                                  
                                  <dt>Market subtotal</dt>
                                  <dd></dd>
                                  
                                  <dt>Commission</dt>
                                  <dd></dd>
                                  
                                  <dt>Net Market Total</dt>
                                  <dd class="net_total"></dd>
                                </dl>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> 
          </div>
        </div>
      </div>
  </div>

  
<app-footer-main></app-footer-main>


<!-- Date Time Picker -->
<ng-template #popTemplate>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="date" [ngModelOptions]="{standalone: true}" [minDate]="minDate" [showWeeks]="false"
        (ngModelChange)="updateDate()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="time" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateTime()" [showMeridian]="isMeridian">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>
<ng-template #popTemplate1>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}" [minDate]="minDate" [showWeeks]="false"
        (ngModelChange)="updateEndDate()" (selectionDone)="dateSelectionDone()">
    </datepicker> 
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateEndTime()"
        [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>